import { useContext } from 'react';
import { createContext } from 'react';

import { DrawerProps } from '../@types/DrawerProps';

export const DrawerContext = createContext<DrawerProps>({} as DrawerProps);

DrawerContext.displayName = 'Drawer';

const DrawerProvider = (props: DrawerProps) => (
	<DrawerContext.Provider value={props}>{props.children}</DrawerContext.Provider>
);

export const useDrawer = () => {
	const context = useContext(DrawerContext);

	return context;
};

export default DrawerProvider;
